import { Button, Flex, Text } from "@chakra-ui/react";

interface Props {
  buttonText?: string;
  buttonIcon?: any;
  handleOpen?: () => void;
  header: string;
}

const Header = ({ buttonText, buttonIcon, handleOpen, header }: Props) => {
  return (
    <Flex
      sx={{
        direction: {
          md: "row",
          base: "column",
        },
        gap: "1rem",
      }}
      justifyContent="space-between"
      borderBottom="1px solid #e8e6e6"
      alignItems={{
        md: "center",
        base: "flex-start",
      }}
      pb="1"
      mb="1"
    >
      <Text
        color="#121212"
        sx={{
          fontSize: "15px",
        }}
      >
        {header}
      </Text>
      {buttonText && handleOpen && (
        <Button
          onClick={() => {
            handleOpen();
          }}
          size="sm"
          variant="primary"
        >
          {buttonText} &nbsp; {buttonIcon}
        </Button>
      )}
    </Flex>
  );
};

export default Header;
